import PropTypes from 'prop-types';
import { ODSAccordion } from '@telekom-ods/react-ui-kit';
import { Grid } from '@mui/material';

const Accordion = ({
  title,
  details,
  children,
  size = 'large',
  expanded,
}) => {
  const content = (
    <Grid container direction="column">
      {details}
      {children}
    </Grid>
  );
  return (
    <ODSAccordion
      headerText={title}
      contentSlot={content}
      size={size}
      expanded={expanded}
    />
  );
};

Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  details: PropTypes.node,
  children: PropTypes.node,
  size: PropTypes.oneOf(['small', 'large']),
  expanded: PropTypes.bool,
};

export default Accordion;
